export default __webpack_public_path__ + "static/media/socialBg.476cba65.png";